/**
 * @format
 */
import {
  GET_LIST_VIEWER_FAILURE,
  GET_LIST_VIEWER_REQUEST,
  GET_LIST_VIEWER_SUCCESS,
} from '../actions';

export default (state, type, payload) => {
  switch (type) {
    case GET_LIST_VIEWER_REQUEST:
      return Object.assign({}, state, {
        listViewerLoading: true,
      });

    case GET_LIST_VIEWER_SUCCESS: {
      const { listViewers, list_id } = payload;

      let updatedListMembers = { ...state.listMembers };
      let updatedListsWithAccessToAllMembers = {
        ...state.listsWithAccessToAllMembers,
      };

      if (listViewers === 'all') {
        // Clear just this list_id from listMembers and set access to true
        delete updatedListMembers[list_id];
        updatedListsWithAccessToAllMembers[list_id] = true;
      } else {
        // Replace just this list_id, set access to false
        const newViewersById = listViewers.reduce((acc, viewer) => {
          acc[viewer.id] = { ...viewer };
          return acc;
        }, {});
        updatedListMembers[list_id] = newViewersById;
        updatedListsWithAccessToAllMembers[list_id] = false;
      }

      return {
        ...state,
        listViewerLoading: false,
        listMembers: updatedListMembers,
        listsWithAccessToAllMembers: updatedListsWithAccessToAllMembers,
      };
    }

    case GET_LIST_VIEWER_FAILURE: {
      return Object.assign({}, state, {
        listViewerLoading: false,
        listViewerError: payload,
      });
    }

    default:
  }
};
